<div class="support-driver-body">
	<div class="flex flex-row" style="margin-bottom: 40px; align-items: center">
		<div class="support-driver-header__label">Dashboard</div>
		<div style="margin-left: auto">
			<p-calendar [appendTo]="'body'"
						[inputStyle]="{'height': '45px', 'background-color': 'white', 'color': 'black'}"
						selectionMode="range" [readonlyInput]="true" [showIcon]="true" [(ngModel)]="selectedDateRange">
			</p-calendar>
		</div>
		<div class="support-driver-header__separator"></div>
		<div>
			<button style="height: 35px;" class="bluedark-btn" pButton label="Export Data" (click)="op.toggle($event)"></button>

			<p-overlayPanel #op [style]="{width: '180px'}">
				<ng-template pTemplate>
					<div class="support-driver-top-button">Download Report</div>
					<div class="support-driver-top-button">Email Report</div>
				</ng-template>
			</p-overlayPanel>
		</div>
	</div>

	<div class="support-driver-card">
		<div class="support-driver-card__header">
			<div class="support-driver-card-title">Complaints</div>
		</div>

		<div class="support-driver-card-title-separator"></div>

		<div class="support-driver-overview-flex">
			<div class="support-driver-overview-column">
				<div class="support-driver-overview-column__header">
					<div class="support-driver-overview-column__header-title">NEW COMPLAINTS</div>
					<div [ngClass]="{
						 'support-driver-overview-column__header-percent-green' : 0>= 0,
						'support-driver-overview-column__header-percent-red': 0 < 0}">
						<span class="support-driver-percent-icon-img">
							<img *ngIf="0 >= 0" src="/Content/xpress-app/images/svg/icon_arrow_up.svg" />
							<img *ngIf="0 < 0" src="/Content/xpress-app/images/svg/icon_arrow_down.svg" />
						</span>0 %
					</div>
				</div>

				<div class="support-driver-overview-column__check">
					<span class="support-driver-check-icon-img"><img src="/Content/xpress-app/images/icon_complaints.png" /></span> 0
				</div>
			</div>

			<div class="support-driver-overview-column">
				<div class="support-driver-overview-column__header">
					<div class="support-driver-overview-column__header-title">PENDING COMPLAINTS</div>
					<div [ngClass]="{
						 'support-driver-overview-column__header-percent-green' : 0>= 0,
						'support-driver-overview-column__header-percent-red': 0 < 0}">
						<span class="support-driver-percent-icon-img">
							<img *ngIf="true" src="/Content/xpress-app/images/svg/icon_arrow_up.svg" />
							<img *ngIf="false" src="/Content/xpress-app/images/svg/icon_arrow_down.svg" />
						</span>0 %
					</div>
				</div>

				<div class="support-driver-overview-column__check">
					<span class="support-driver-check-icon-img"><img src="/Content/xpress-app/images/icon_complaints.png" /></span> 0
				</div>
			</div>

			<div class="support-driver-overview-column">
				<div class="support-driver-overview-column__header">
					<div class="support-driver-overview-column__header-title">CLOSED COMPLAINTS</div>
					<div [ngClass]="{
						 'support-driver-overview-column__header-percent-green' : 0>= 0,
						'support-driver-overview-column__header-percent-red': 0 < 0}">
						<span class="support-driver-percent-icon-img">
							<img *ngIf="0 >= 0" src="/Content/xpress-app/images/svg/icon_arrow_up.svg" />
							<img *ngIf="0 < 0" src="/Content/xpress-app/images/svg/icon_arrow_down.svg" />
						</span>0 %
					</div>
				</div>

				<div class="support-driver-overview-column__check">
					<span class="support-driver-check-icon-img"><img src="/Content/xpress-app/images/icon_complaints.png" /></span> 0
				</div>
			</div>
		</div>
	</div>
</div>